export default __webpack_public_path__ + "static/media/tomas_arad_red_rose.516ad90e.svg";